export function catalogueMealPayload(data: Record<string, any>, canEditPrices = true) {
  const payload = { ...data };
  // Editing recipe or pricing must not overwrite availability refreshed since the form loaded.
  delete payload.isAvailable;
  delete payload.currentStock;
  if (!canEditPrices) {
    delete payload.currentPrice;
    delete payload.mrp;
  }
  return payload;
}
